import { c as _c } from "react/compiler-runtime";
import { Spinner } from "@/components/dotLoader/DotLoader";
import type { WaveNotificationSettingsState } from "./useWaveNotificationSettings";
interface WaveNotificationRetryButtonProps {
  readonly settings: WaveNotificationSettingsState;
  readonly compact?: boolean | undefined;
}
export default function WaveNotificationRetryButton(t0) {
  const $ = _c(10);
  const {
    settings,
    compact: t1
  } = t0;
  const compact = t1 === undefined ? false : t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <span>Retry</span>;
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  let buttonContent = t2;
  if (settings.preferencesFetching) {
    let t3;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
      t3 = <Spinner dimension={12} />;
      $[1] = t3;
    } else {
      t3 = $[1];
    }
    buttonContent = t3;
  }
  const t3 = compact ? "tw-inline-flex" : "tw-w-full";
  const t4 = `tw-flex tw-items-center tw-justify-center tw-whitespace-nowrap tw-rounded-lg tw-border tw-border-solid tw-border-iron-700 tw-bg-transparent tw-text-[13px] tw-text-iron-400 tw-transition tw-duration-300 tw-ease-out disabled:tw-cursor-not-allowed disabled:tw-text-iron-500 desktop-hover:hover:tw-text-iron-300 ${compact ? "tw-h-9 tw-px-3" : "tw-h-10 tw-w-full tw-px-3 lg:tw-h-9"}`;
  let t5;
  if ($[2] !== buttonContent || $[3] !== settings.onRetryClick || $[4] !== settings.preferencesFetching || $[5] !== t4) {
    t5 = <button type="button" disabled={settings.preferencesFetching} onClick={settings.onRetryClick} className={t4} aria-label="Retry notification settings">{buttonContent}</button>;
    $[2] = buttonContent;
    $[3] = settings.onRetryClick;
    $[4] = settings.preferencesFetching;
    $[5] = t4;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== t3 || $[8] !== t5) {
    t6 = <div className={t3}>{t5}</div>;
    $[7] = t3;
    $[8] = t5;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  return t6;
}